<template>
    <transition name="toast">
        <div v-if="visible" class="toast" :class="type">
            <span>{{ message }}</span>
            <div class="progress" />
        </div>
    </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";

const visible = ref(false);
const message = ref("");
const type = ref<"success" | "error">("success");

let timer: number | null = null;

function show(msg: string, t: "success" | "error" = "success") {
    message.value = msg;
    type.value = t;
    visible.value = true;

    if (timer) clearTimeout(timer);
    timer = window.setTimeout(() => {
        visible.value = false;
    }, 3000);
}

function handler(e: any) {
    show(e.detail.message, e.detail.type);
}

onMounted(() => {
    window.addEventListener("toast", handler);
});

onBeforeUnmount(() => {
    window.removeEventListener("toast", handler);
});
</script>

<style scoped>
.toast {
    position: fixed;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    padding: 12px 18px;
    border-radius: 14px;
    font-size: 14px;
    color: #fff;
    z-index: 9999;
    min-width: 240px;
    text-align: center;
}

.toast.success {
    background: #22c55e;
}

.toast.error {
    background: #ef4444;
}

.progress {
    height: 3px;
    background: rgba(255, 255, 255, 0.7);
    margin-top: 8px;
    border-radius: 2px;
    animation: progress 3s linear forwards;
}

@keyframes progress {
    from {
        width: 100%;
    }

    to {
        width: 0%;
    }
}

.toast-enter-from,
.toast-leave-to {
    opacity: 0;
    transform: translate(-50%, 20px);
}

.toast-enter-active,
.toast-leave-active {
    transition: all 0.3s ease;
}
</style>
